import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import { injectIntl } from "react-intl";
import CompanyListing from "./company/CompanyListing/CompanyListing";
import GroupsListing from "./groups/GroupsListing/GroupsListing";

class Clients extends React.Component {
  render() {
    return (
      <Tabs defaultActiveKey="company" id="clientsTabs">
        <Tab
          eventKey="company"
          title={this.props.intl.formatMessage({ id: "Pharmacies" })}
        >
          <CompanyListing />
        </Tab>
        <Tab
          eventKey="groups"
          title={this.props.intl.formatMessage({
            id: "Groups",
          })}
        >
          <GroupsListing />
        </Tab>
      </Tabs>
    );
  }
}

export default injectIntl(Clients);
